import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";

/** Payload of `RevokeApiTokenCommand`: the uid (ShortId) of the token to revoke. */
export class RevokeApiTokenContent extends CommandPayload {

    @Expose()
    public tokenUid: string;

    public constructor(tokenUid: string) {
        super();
        this.tokenUid = tokenUid;
    }
}
